// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b7c8d88c","977":"a536ba23"}[chunkId] + ".chunk.js";
};